import GetWidgetHostConfigByIdAsyncRequestModelBase from '../_generated/modelBases/get-widget-host-config-by-id-async-request-model-base';

export default class GetWidgetHostConfigByIdAsyncRequestModel extends GetWidgetHostConfigByIdAsyncRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
